import * as React from "react";

import useList from "src/core/lists/hooks/useList";
import { canListOrderProduct } from "src/core/orders/utils/orders";
import { useOrder } from "src/core/orders/hooks";
import useOrderingNotAvailableForDay from "src/core/orders/hooks/validation/useOrderingAvailableForDay";
import { IProduct } from "src/core/products/api/products.api";
import { useDrop } from "src/core/drops/hooks";

export default (product: IProduct, unavailable?: string | null): boolean => {
  const [ { currentOrder } ] = useOrder();
  const [ { drop } ] = useDrop();
  const orderingNotAvailableForDay = useOrderingNotAvailableForDay(drop);
  const [ { currentList } ] = useList();

  return React.useMemo(() => {
    let canOrderProd: boolean;

    if (currentList.data) {
      canOrderProd = canListOrderProduct(product, currentList.data.schedule) === null;
    } else {
      canOrderProd = orderingNotAvailableForDay(
        currentOrder.data && currentOrder.data.orderDeliveryDate ? currentOrder.data.orderDeliveryDate : null,
        product
      ) === null;
    }

    if (unavailable) {
      return false;
    } else if (currentOrder.mode === "edit" && !canOrderProd) {
      return false;
    } else if (currentList.mode === "edit" && !canOrderProd) {
      return false;
    } else {
      return true;
    }
  }, [
    currentList.data,
    currentList.mode,
    currentOrder.data,
    currentOrder.mode,
    orderingNotAvailableForDay,
    product,
    unavailable
  ]);
};
